import type React from "react";
import { useState } from "react";
import { Button } from "src/components/ui/button";
import { Input } from "src/components/ui/input";
import { Label } from "src/components/ui/label";
import { sanitizeBrlValue } from "src/utils/functions";
import type { CorrectionPlan } from "../types";
import { parseBrlToNumber } from "../utils/functions";

interface CorrectionPlanFormProps {
  onAdd: (plan: CorrectionPlan) => void;
  onCancel: () => void;
  onError: (message: string) => void;
}

export const CorrectionPlanForm: React.FC<CorrectionPlanFormProps> = ({
  onAdd,
  onError,
}) => {
  const [value, setValue] = useState("");

  const handleSubmit = () => {
    if (!value) {
      onError("Preencha o valor da correção.");
      return;
    }
    const val = parseBrlToNumber(value);

    if (isNaN(val)) {
      onError("Valores numéricos inválidos para correção.");
      return;
    }

    onAdd({
      id: Math.random().toString(36).substring(2, 11),
      valueAnual: val,
      startInstallment: 0,
      endInstallment: 99999,
    });
  };

  return (
    <div className="grid gap-4">
      <div className="grid gap-2">
        <Label>Valor anual TR/IPCA (%)*</Label>
        <Input
          value={value}
          onChange={(e) => setValue(sanitizeBrlValue(e))}
          placeholder="3,14"
        />
        <span className="text-xs text-gray-500">
          A correção será aplicada a todas as parcelas.
        </span>
      </div>
      <div className="flex justify-end">
        <Button
          variant="default"
          type="button"
          className="bg-green-600 hover:bg-green-700 text-white"
          onClick={handleSubmit}
        >
          Adicionar
        </Button>
      </div>
    </div>
  );
};
